import { type ReactNode } from 'react';

import { ButtonSizeContext } from '../components/Button/Button';

export type OverlayBoundaryProps = {
    children: ReactNode;
};

/** Resets the context an overlay inherits from where it is rendered (e.g. `Box.Actions` button size). */
export function OverlayBoundary({ children }: OverlayBoundaryProps) {
    return <ButtonSizeContext.Provider value={undefined}>{children}</ButtonSizeContext.Provider>;
}
